export default "__VITE_ASSET__DDasQ4Bf__"